import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import update, { Spec } from 'immutability-helper';
import { GenericHistoryItem } from './models/history/history.model';

interface HistoryState {
  history: GenericHistoryItem[];
}

const INITIAL_HISTORY: HistoryState = {
  history: [],
};

const NavHistorySlice = createSlice({
  name: 'history',
  initialState: INITIAL_HISTORY,
  reducers: {
    addHistoryItem: (state, action: PayloadAction<GenericHistoryItem>) => {
      const updateOptions: Spec<typeof state.history> = {
        $push: [action.payload],
      };
      state.history = update(state.history, updateOptions);
    },
    removeAfterIndex: (state, action: PayloadAction<number>) => {
      const lastIndexToKeep = action.payload;
      const len = state.history.length;
      if (len === 0) {
        // Nothing to pop
        return;
      }
      if (lastIndexToKeep >= len - 1) {
        // trying to trim after an index which is too high.
        return;
      }
      state.history = update(state.history, {
        $splice: [[lastIndexToKeep + 1, len - lastIndexToKeep + 1]],
      });
    },
    startNewHistory: (state, action: PayloadAction<GenericHistoryItem>) => {
      state.history = [action.payload];
    },
    emptyHistory: (state) => {
      state.history = [];
    },
  },
});

export const {
  addHistoryItem,
  removeAfterIndex,
  startNewHistory,
  emptyHistory,
} = NavHistorySlice.actions;

export default NavHistorySlice.reducer;
